export default function tabulationGalleryReducer(state = null, action) {
  switch (action.type) {
    case 'SET_TABULATION_GALLERY': {
      return {
        ...state,
        galleryTabulation: {
          data: action.payload.data,
        },
      }
    }
    default:
      return state
  }
}
